import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetCustomerLedgerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetCustomerLedgerList?` + params, null);

export const GetSaleRegisterList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetSalesRegisterList?` + params, null);

export const GetPurchaseRegisterList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetPurchaseRegisterList?` + params, null);

export const GetSupplierLeddgerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetSupplierLeddgerList?` + params, null);

export const GetOutstandingReceivableSummaryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/OutstandingReceivableSummaryList?` + params, null);

export const GetOutstandingPayableSummaryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/OutstandingPayableSummaryList?` + params, null);

export const GetOutstandingReceivableList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/OutstandingReceivableList?` + params, null);

export const GetOutstandingReceivableListNew = (data: any) =>
   POST_ENC(`${BASE_URL}/api/Register/OutstandingReceivableListNew`, data).then((apiResponse: any) => ({ data: apiResponse }));

export const GetOutStandingPayableList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/OutStandingPayableList?` + params, null);

export const GetOutStandingPayableListNew = (data: any) =>
   POST_ENC(`${BASE_URL}/api/Register/OutStandingPayableListNew`, data).then((apiResponse: any) => ({ data: apiResponse }));

export const GetCashBookPartyWiseList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/CashbookPartyWise?` + params, null);

export const GetStockTransferSummary = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/StockTransferSummary?` + params, null);

export const GetInvoiceDispatchSummaryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/InvoiceDispatchSummaryList?` + params, null);

export const GetCreditRegisterReportList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetCreditRegisterReportList?` + params, null);

export const GetDebitRegisterReportList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Register/GetDebitRegisterReportList?` + params, null);
